import { Component, effect, input, output } from '@angular/core';
import { Facet, FacetAlias, UserFacet } from "../facet";
import { FacetIcons } from "../facet-icons.const";
import { ButtonColor, ButtonComponent } from "app/shared/button/button.component";
import { IconComponent } from "app/shared/icon/icon.component";
import { TabsFilterComponent } from "app/shared/tabs-filter/tabs-filter.component";

@Component({
  selector: 'app-multi-facet-pills',
  imports: [
    ButtonComponent,
    IconComponent,
    TabsFilterComponent
  ],
  standalone: true,
  templateUrl: './multi-facet-pills.component.html',
  styleUrls: ['./multi-facet-pills.component.scss'],
})
export class MultiFacetPillsComponent {
  facets = input.required<UserFacet[] | undefined>();
  selectedFacets = input<FacetAlias[]>([]);
  facetType = input<'all' | 'user' | 'userNoChapter'>('user');
  isDetaied = input(false);
  selected = output<{facet: UserFacet, selected: boolean}>();

  constructor() {}

  onSelected(facet: UserFacet) {
    if (this.selectedFacets().includes(facet.alias)) {
      this.selected.emit({
        facet,
        selected: false
      });
    } else {
      this.selected.emit({
        facet, selected: true
      });
    }
  }

  getFacetIcon(facet: UserFacet): string {
    return FacetIcons[facet.alias];
  }

  getFacetName(facet: UserFacet): string {
    return facet.alias === FacetAlias.chapter ? '' : facet.name ? facet.name : 'Unnamed';
  }

  getFacetColor(facet: UserFacet): ButtonColor {
    return this.selectedFacets().includes(facet.alias) ? 'blue' : 'outlineBlue';
  }

  getButtonClass(facet: Facet): string {
    if (this.facetType() === 'user') {
      return this.selectedFacets().includes(facet.alias) ? 'selected-button-user' : 'button-user';
    }

    return ''
  }
}
